import { useContext } from "react";
import LanguageContext from "../context/language";
import CookiePolicyEN from "../components/cookie-policies/cookie-policy_EN";
import CookiePolicyIT from "../components/cookie-policies/cookie-policy_IT";
import CookiePolicyFR from "../components/cookie-policies/cookie-policy_FR";
import useTealiumOnPageLoad from "../utils/tealium";
import CookiePolicyES from "../components/cookie-policies/cookie-policy_ES";
import CookiePolicyPT from "../components/cookie-policies/cookie-policy_PT";

const CookiePolicy = ({ logged, setNavigation, appLang }) => {
  const { cmsLanguages } = useContext(LanguageContext);
  const lang = cmsLanguages.find((lang) => lang.profile === appLang?.value)?.value;
  useTealiumOnPageLoad({ pageSection1: "cookie-policy" });

  return {
    "en-us": <CookiePolicyEN logged={logged} setNavigation={setNavigation} />,
    "it-it": <CookiePolicyIT logged={logged} setNavigation={setNavigation} />,
    "fr-fr": <CookiePolicyFR logged={logged} setNavigation={setNavigation} />,
    "es-es": <CookiePolicyES logged={logged} setNavigation={setNavigation} />,
    "pt-br": <CookiePolicyPT logged={logged} setNavigation={setNavigation} />,
  }[lang];
};

export default CookiePolicy;
